import Vue from 'vue';

import {
  LanguageSwitch,
} from '@/components';

import Logo from '@/assets/images/logo/logo.svg';

export default {
  name: 'Header',
  components: {
    [LanguageSwitch.name]: LanguageSwitch,
    Logo,
  },
  props: {},
  data: () => ({}),
  computed: {
    language() {
      return Vue.config.language;
    },
    requiredImageUrl() {
      return require(
        '@/assets/images/logo/logo.svg',
      );
    },
  },
  methods: {},
};
